// extracted by mini-css-extract-plugin
export default {"container":"_3KCdU","buttonLayout":"_1eyf0","textLayout":"_1QMeQ"};